import { useState, useCallback } from "react";
import { getWalletBalances } from "@/lib/api";

/** FMI + USDT balances for the connected wallet (backend first, wallet RPC fallback for FMI). */
export function useBalances(providerRef) {
  const [balance, setBalance] = useState(null);
  const [usdtBalance, setUsdtBalance] = useState(null);

  const loadBalances = useCallback(async (addr) => {
    // Keep the last known values on transient failures so balances never flicker away
    const live = await getWalletBalances(addr).catch(() => null);
    if (live?.fmi != null) {
      setBalance(live.fmi.toFixed(4));
    } else {
      const bal = await providerRef.current?.request({ method: "eth_getBalance", params: [addr, "latest"] }).catch(() => null);
      // Transient RPC failure: intentionally keep the last known balance (no flicker, no toast spam on polling)
      if (bal) setBalance((parseInt(bal, 16) / 1e18).toFixed(4));
    }
    if (live?.usdt != null) setUsdtBalance(live.usdt.toLocaleString(undefined, { maximumFractionDigits: 2 }));
  }, [providerRef]);

  const clearBalances = useCallback(() => {
    setBalance(null);
    setUsdtBalance(null);
  }, []);

  return { balance, usdtBalance, loadBalances, clearBalances };
}
